// GENERATED by scripts/build-icons.mjs from icons/download.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Download = createIcon('download', [
  ['path', { d: "M12 15V3" }],
  ['path', { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }],
  ['path', { d: "m7 10 5 5 5-5" }],
])
